var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11.61 11.613",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_edit_3556018_000000",
    transform: "matrix(1, 0, 0, 1, -18, -17.999001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M40.444,18a2.251,2.251,0,0,0-1.6.664l-3.778,3.778A3.6,3.6,0,0,0,34,25.008v1.7h1.7a3.609,3.609,0,0,0,2.566-1.063l3.779-3.78A2.266,2.266,0,0,0,40.444,18Zm.576,2.841-3.778,3.778a2.162,2.162,0,0,1-1.54.639h-.249v-.249a2.162,2.162,0,0,1,.637-1.54l3.779-3.78a.815.815,0,1,1,1.15,1.15Z",
    transform: "translate(-13.097)",
    fill: "#5636d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M20.177,32.887h6.532a2.177,2.177,0,0,0,2.177-2.177v-2.9H27.435v2.9a.726.726,0,0,1-.726.726H20.177a.725.725,0,0,1-.726-.726V24.177a.725.725,0,0,1,.726-.726h2.9V22h-2.9A2.177,2.177,0,0,0,18,24.177v6.532A2.177,2.177,0,0,0,20.177,32.887Z",
    transform: "translate(0 -3.275)",
    fill: "#5636d0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-icon.e879005f.svg";
export { ForwardRef as ReactComponent };